import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { userAnalytics } from '../utils/analytics/userAnalytics';
import { AnalyticsPageActionEnum } from '../types/customLogger';

export default function useRouteLoggerHook() {
  const location = useLocation();

  useEffect(() => {
    userAnalytics(AnalyticsPageActionEnum.MOUNTED, location.pathname)
  }, [location.pathname]);
  return null;
}
